import styled from "styled-components";

const MarkdownStyle = styled.div`
  h1,
  h2,
  h3,
  h4,
  h5 {
    color: ${props => props.theme.colors.text};
    line-height: 1.45;
    margin: 0;
    font-weight: ${props => props.theme.weights.bold};
  }

  h1 {
    font-size: ${props => props.theme.fontSizes.xl};
    margin-bottom: ${props => props.theme.margins.lg};
    border-bottom: 2px solid ${props => props.theme.colors.lightGrey};
  }

  h2 {
    font-size: ${props => props.theme.fontSizes.lg};
    margin-bottom: ${props => props.theme.margins.md};
    margin-top: ${props => props.theme.margins.lg};
  }

  h3 {
    font-size: ${props => props.theme.fontSizes.md};
    margin-bottom: ${props => props.theme.margins.nm};
  }

  h4 {
    font-size: ${props => props.theme.fontSizes.nm};
    font-weight: ${props => props.theme.weights.normal};
    margin-bottom: ${props => props.theme.margins.lg};
  }

  h5 {
    font-size: ${props => props.theme.fontSizes.lg};
    font-weight: ${props => props.theme.weights.thin};
    margin-bottom: ${props => props.theme.margins.lg};
  }

  p,
  b,
  strong,
  a,
  ul,
  ol li {
    font-size: ${props => props.theme.fontSizes.nm};
    font-weight: ${props => props.theme.weights.regular};
    line-height: 1.75;
    padding-bottom: ${props => props.theme.margins.md};
    color: ${props => props.theme.colors.text};
    margin: 0;
  }

  p:last-of-type {
    padding-bottom: 20px;
  }

  a {
    line-height: 1.5;
    color: ${props => props.theme.colors.text};
    background: ${props => props.theme.colors.lightLink};
    padding: 0 3px;
    text-decoration: none;
    transition: background 0.15s ease-out;
    &:visited {
      background: ${props => props.theme.colors.lightLink};
    }
    &:hover {
      background: ${props => props.theme.colors.link};
    }
  }

  ul {
    list-style: none;
    padding-bottom: 0;
  }

  ol {
    padding-bottom: 0;
  }

  ul li,
  ol li {
    font-size: ${props => props.theme.fontSizes.nm};
    line-height: 1.75;
    padding-bottom: 0;
    margin: 0 0 ${props => props.theme.margins.md};
    &:last-of-type {
      padding-bottom: 0;
    }
  }

  ul li:before {
    content: "- ";
  }

  blockquote {
    margin: ${props => props.theme.margins.lg} 3rem
      ${props => props.theme.margins.xl} 3rem;
    font-style: italic;
    font-size: ${props => props.theme.fontSizes.md};
  }

  blockquote p {
    font-size: ${props => props.theme.fontSizes.md};
    font-weight: 300;
    color: ${props => props.theme.colors.text};
    padding-bottom: ${props => props.theme.margins.sm};
    line-height: 1.55;
    opacity: 0.65;
  }

  strong {
    font-weight: ${props => props.theme.weights.bold};
  }

  code {
    font-family: ${props => props.theme.fontFamily.code};
    background: ${props => props.theme.colors.codeHighlight};
    padding: 0 3px;
  }

  pre {
    display: flex;
  }

  img {
    width: 100%;
  }

  iframe {
    width: 100%;
    flex: 1 0 auto;
    margin-top: ${props => props.theme.margins.lg};
    height: 1000px;
  }
  video {
    width: 100%;
  }
`;

export default MarkdownStyle;



// WEBPACK FOOTER //
// ./src/helpers/MarkdownStyle.js